// 報導者特別獎靜態資料
// 這些資料是根據舊版網站內容整理的

export interface ReporterSpecialAwardItem {
  year: string;
  type: string; // 國小A組、國小B組、國中C組、國中D組
  groupno: string; // 隊伍編號，用於匹配資料庫
  specialAwardName: string; // 特殊獎項名稱（如「新工具探索獎」）
  reason: string; // 獲獎原因
  topic?: string; // 探究題目（從舊版提取）
  students?: string; // 學生姓名（從舊版提取，格式：姓名(年級) 姓名(年級)...）
  schoolInfo?: string; // 完整的學校和隊伍資訊（從舊版提取，格式：縣市學校名稱 (隊伍編號) 隊伍名稱）
}

export const reporterSpecialAwardData: ReporterSpecialAwardItem[] = [
  // 114年度
  {
    year: '114年度',
    type: '國小A組',
    groupno: 'HA010-07',
    specialAwardName: '新工具探索獎',
    topic: '小學生適合用AI嗎？',
    schoolInfo: '新竹縣中山國小 (HA010-07) 未來小隊',
    students: '', // 舊版未顯示學生姓名
    reason: '人工智慧已深入生活，小學生的提問也不再只是「能不能用AI」，而是更進一步思考：「該怎麼用？哪一種最適合我們？」<br>他們透過探究的歷程，主動蒐集市面常見的AI軟體，分析功能差異，進行個人試用與評比，並針對自身年齡層提出具體建議。在教師與家長的引導下，小學生適度運用AI，應用於圖像生成、語音互動或簡易搜尋等。<br>面對日新月異的科技，展現出數位時代中思辨與行動並重的學習精神。'
  },
  {
    year: '114年度',
    type: '國小B組',
    groupno: 'HB007-02',
    specialAwardName: '責任思辨獎',
    topic: '校園打掃大家一起來',
    schoolInfo: '新北市實踐國小 (HB007-02) 不知道晚一點再說隊',
    students: '', // 舊版未顯示學生姓名
    reason: '提出一個好問題，是獨立思考的起點。這組小學生從日常的校園打掃出發，進一步思考其責任應由誰來承擔。他們不僅從「打掃有助於培養學生品格」這個觀點切入，更在探究過程中嘗試超越「願不願意」的個人感受，轉向透過資料蒐集與比較國際做法，逐步進行辯證與討論。這樣的過程，不僅深化了對責任與公共空間的理解，也展現了小學生參與公共事務、發展公民素養的初步萌芽。'
  },
  {
    year: '114年度',
    type: '國中C組',
    groupno: 'HC015-01',
    specialAwardName: '毛孩勇士獎',
    topic: '十二夜之後：流浪貓狗的終養？',
    schoolInfo: '臺中市四育國中 (HC015-01) 森江貓狗隊',
    students: '', // 舊版未顯示學生姓名
    reason: '同學展現很強的共感能力，關懷生活周遭事物，看見非人的流浪貓狗困境，進而延伸至動物生命權議題的討論。探究架構完整度高，爬梳台灣的零安樂死政策脈絡，也援引國際案例參考比較，提出多方面的解方。此外，藉由線上探究了解議題後，還能身體力行在校園舉辦快閃宣導活動，為無法說話的毛孩發聲，令評審動容。'
  },
  {
    year: '114年度',
    type: '國中D組',
    groupno: 'HD024-02',
    specialAwardName: '新聞模範生獎',
    topic: '誰在說謊？ 一起來抓假新聞！',
    schoolInfo: '桃園市平鎮國中 (HD024-02) 明星三缺一隊',
    students: '', // 舊版未顯示學生姓名
    reason: '這隊的問題核心圍繞媒體識讀，且報告時「新聞性」十足，起頭就以網友假冒三峽車禍肇事老翁親人的事件帶出假新聞的實際樣貌，安排用心。在發現社會問題後，小隊更積極尋找改善的方法，不僅發放600份問卷掌握身旁同學對假新聞的判別能力，更運用AI工具製作假新聞篩選器，展現優異的數位能力與媒體素養。'
  },
  
  // 113年度
  {
    year: '113年度',
    type: '國小A組',
    groupno: 'GA022-01',
    specialAwardName: '新聞思辨獎',
    topic: '到底該不該保留博愛座？',
    schoolInfo: '臺中市東區臺中國民小學-小學生也能作專題 (GA022-01)',
    students: '王藝晴(4) 李昀叡(4) 廖藝媃(4)',
    reason: '選擇了一個有趣並能廣泛引發討論的題目，不停留在口水之爭，而能從源頭的法規、制度面著手，並綜整不同國家、不同文化背景的立場，展現出新聞素養及批判性思維。'
  },
  {
    year: '113年度',
    type: '國小B組',
    groupno: 'GB013-01',
    specialAwardName: '社會正義獎',
    topic: '民眾檢舉交通違規的影響',
    schoolInfo: '新北市新莊區新莊國民小學-summer spring (GB013-01)',
    students: '蔡心甯(6) 胡心瑀(6) 莊千霈(5)',
    reason: '能從自身觀察和家人經驗出發，不盲從社會觀感，進而探究檢舉背後的利弊得失，以及探討修法前後影響的比較，從政策面著手理解背後立法的用意，實際走了一趟公平正義的探究之旅。'
  },
  {
    year: '113年度',
    type: '國中C組',
    groupno: 'GC021-02',
    specialAwardName: '敞開心扉獎',
    topic: '探究炮炸寒單爺文化與臺東社會的互動與影響',
    schoolInfo: '臺東縣立東海國民中學-啊豆雲B (GC021-02)',
    students: '簡維恩(8) 蔡禾鈞(8) 姜品岑(8) 林秝羽(8)',
    reason: '能從生活周遭挖掘陌生的事物，展現強烈地好奇心，甚至為了觸及更多想法走出教室訪問相關人物，並且能犀利察覺到自身對特定事物可能帶有偏見，進一步深入探究網路報導是否全面，不抱成見的探究態度難能可貴。'
  },
  {
    year: '113年度',
    type: '國中D組',
    groupno: 'GD033-21',
    specialAwardName: '你就是柯南獎',
    topic: '你騙不了我的!如何避開網紅所設下的造假陷阱?',
    schoolInfo: '臺中市立光明國民中學-三色豆 (GD033-21)',
    students: '謝妙可(8) 林睿昕(8) 邱妍炘(8)',
    reason: '從網路世代最流行的職業下手，一步步剖析「網紅」拍片的心態，並進一步探究如何不輕易上當，知道「主流聲音不一定都是對的」，即是有意識、懂思考的閱聽人最佳示範。'
  },
  
  // 112年度
  {
    year: '112年度',
    type: '國小A組',
    groupno: 'FA047-01',
    specialAwardName: '變髮圖強獎',
    topic: '小學生適合染頭髮嗎？',
    schoolInfo: '基隆市七堵區復興國民小學-友蚋I KNOW (FA047-01)',
    students: '高苡菱 (4)周妤潔 (4)張芷睿 (4)安芮亞 (4)',
    reason: '身體形象是自我探索重要的管道、亦是社會最刻板化的約束，這個題目看似微小、但直指社會內在價值，討論的層面寬廣、層次也很高。而同學們除整理一般媒體報導，蒐羅了許多學術論文，由教育、健康、心理和價值展開，資料扎實，是一次針對社會文化面向讓人驚喜的提問與探討。'
  },
  {
    year: '112年度',
    type: '國小B組',
    groupno: 'FB036-01',
    specialAwardName: '社會小太陽獎',
    topic: '如何幫助街友?',
    schoolInfo: '基隆市安樂區建德國民小學-基隆街友愛隊 (FB036-01)',
    students: '陳簡君 (6)許妙多 (6)陳彥暟 (6)魏妤恩 (6)',
    reason: '這是一個非常有愛(友愛)的題目，同學們由社區生活圈的觀察出發，透過各種資料的整理歸納，再回到真實社會做訪談，留下一篇具有溫度的探索報告。最「可信」的資料，永遠來自「最接近」當事者的現場，同學們真誠地留下了對街友不自覺的刻板印象，自我修正以更多元的角度去看待街友，這樣的歷程本身，就在研究同學的心中以及社會角落，灑下了溫暖的種籽。'
  },
  {
    year: '112年度',
    type: '國中C組',
    groupno: 'FC003-02',
    specialAwardName: '有你真好獎',
    topic: '導盲犬的前世今生與未來',
    schoolInfo: '桃園市桃園區經國國民中學-綿鹽王隊 (FC003-02)',
    students: '王瑄蕥 (8)徐嘉彤 (8)賴言瑄 (8)',
    reason: '同時關注動物權益及視障者自主生活的權益，探討導盲犬的歷史由來，並思索未來新科技下的其他的替代可能，探究議題有新意，同學在線上的資料整理與探究後，亦能完整表達個人觀點與學習，實屬難得。'
  },
  {
    year: '112年度',
    type: '國中D組',
    groupno: 'FD024-05',
    specialAwardName: '倡議先鋒獎',
    topic: '台灣《菸害防制法》修法對青少年的意義為何？',
    schoolInfo: '嘉義市立民生國中-荷葉隊 (FD024-05)',
    students: '翁嘉彤 (7)劉禹岑 (7)何承燁 (7)',
    reason: '《菸害防制法》的修法背後牽動的原因錯綜複雜，但同學們卻能在查找資料過程中不時回到對自身、對同年齡族群的關心，進一步探究校園中新興菸品對青少年潛藏的危害，喚起社會重視，並提出來自學生觀點的倡議主張，若有機會繼續深化成具體行動，將會是相當棒的校園倡議先鋒部隊。'
  },
  
  // 111年度
  {
    year: '111年度',
    type: '國小A組',
    groupno: 'EA011-01',
    specialAwardName: '社會小太陽獎',
    topic: '越南新住民媽媽如何融入臺灣的社會生活？',
    schoolInfo: '桃園市龜山區新路國民小學—「新」欣向榮 (EA011-01)',
    students: '蔡安絜(5)、蔡沛軒(5)、葉巧宜(5)、羅湘琳(5)',
    reason: '這是獲選團隊中，由「真實世界」去驗證和尋找議題方向與答案，辯別數位資訊品質與真假最好的方式，有時就是最笨和最簡單的方式—尋求事件和議題的「當事人」與「關注者」的說法。由身邊的人感受到了世界的異質性，透過提問、討論和尋找答案的過程，建構起對世界的關懷眼光，這是最棒的探索。雖不是大議題，但很動人。'
  },
  {
    year: '111年度',
    type: '國小B組',
    groupno: 'EB023-01',
    specialAwardName: '經濟小學人獎',
    topic: '虛擬網紅對真實世界產生什麼影響',
    schoolInfo: '臺北市私立再興小學—二次元の扉 (EB023-01)',
    students: '陳鍇絡(6)、關野優美(6)、高宇莘(6)',
    reason: '虛擬網紅是現下中小學生的熱門議題，這次4個組別中相關探索議題極多，這組的架構既龐大又細緻，搜尋的面向和廣度扎實，最讓人眼睛一亮的是，推翻了初時的假設，也掙開單純道德規範的論述，在商業模式架構梳理清楚，而這個過程和發現，正是所有疑問與沉迷份際拿捏，最好的解答。'
  },
  {
    year: '111年度',
    type: '國中C組',
    groupno: 'EC046-01',
    specialAwardName: '青春代言人獎',
    topic: '戀戀青春--從校園的禁愛令談起',
    schoolInfo: '嘉義縣朴子市東石國民中學—2加2大於4 (EC046-01)',
    students: '康喬茵(8)、張尹薰(8)、莊沛珆(8)、呂翊瑄(8)',
    reason: '這個議題是由青少年自身出發，向成人社會提出對青少年談戀愛的「保護」與「侵襲」的提問，由敏感的社會風暴到科學的大腦風暴，相關的情、理、法，身體與心理很全面進行討論與深究，發現「學生可以談戀愛竟然有國家法令的保障」，卻也提出「談戀愛不用靠個人摸索，可以透過家庭教育、學校教育來學習」觀點，很有說服力和可讀性的議題。'
  },
  {
    year: '111年度',
    type: '國中D組',
    groupno: 'ED037-01',
    specialAwardName: '真正有影獎',
    topic: '迪士尼角色中女性形象的改變',
    schoolInfo: '南山學校財團法人新北市南山高級中學(國中部)—ESL (ED037-01)',
    students: '朱芷瑩(7)、海語芯(7)、吳惠真(7)',
    reason: '這個題目，雖然是探討迪士尼電影裡歷來「公主」人設的改變，進而帶出性平的探討。不過，其中最有『愛』、也最有『看頭』的部分，其實是對迪士尼動畫的影癡等級，這組同學所有的題目發想都來自「娛樂」和「休閒」，似乎不是「政(治)經(濟)」的嚴肅題目，其實，所有與人們生活相關的事，一旦「認真」起來，都會有「精彩」的發現。'
  }
];

// 根據年度和組別取得特殊獎項資料
export const getReporterSpecialAwardByYearAndType = (year: string, type: string): ReporterSpecialAwardItem | undefined => {
  return reporterSpecialAwardData.find(item => item.year === year && item.type === type);
};

// 根據年度和隊伍編號取得特殊獎項資料
export const getReporterSpecialAwardByYearAndGroupno = (year: string, groupno: string): ReporterSpecialAwardItem | undefined => {
  return reporterSpecialAwardData.find(item => item.year === year && item.groupno === groupno);
};

